import {transient} from "aurelia-framework";
import {
    ValidationRenderer,
    RenderInstruction,
    ValidateResult
} from "aurelia-validation";

/**
 * Note that at this time, properties whose validation rules are defined by ensureObject.satisfy() are not being associated with elements,
 * and thus will not be highlighted by this code.
 */
@transient()
export class FormSchemaCollectionValidationRenderer implements ValidationRenderer, IFormSchemaCollectionValidationRenderer {

    // is calling render on 4 different instances, but with the same instruction.
    render(instruction: RenderInstruction): void {

        // console.log(instruction);
        /**
         * property-level
         */
        for (let { result, elements } of instruction.unrender) {
            for (let element of elements) {
                this.remove(element, result);
            }
        }

        for (let { result, elements } of instruction.render) {
            for (let element of elements) {
                this.add(element, result);
            }
        }
    }

    private add(element: Element, result: ValidateResult): void {

        const container: any = $(element).closest(".fld")[0];
        if (!container) {
            return;
        }

        if (!result.valid) {
            // console.log(`add validation error: ${error.propertyName}: ${error.message}`);
            container.classList.add("has-error");
        }
    }

    private remove(element: Element, result: ValidateResult): void {
        const container: any = $(element).closest(".fld")[0];
        if (!container) {
            return;
        }
        // console.log(`remove validation error: ${error.propertyName}: ${error.message}`);
        container.classList.remove("has-error");
    }
}

export interface IFormSchemaCollectionValidationRenderer extends ValidationRenderer {
}
